import React from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

export const InputDateTime = (props) => {
  const { label, id, value, onChange, isRequired, isError } = props;
  return (
    <div style={{ display: "grid" }}>
      <label>
        {label}
        {isRequired && (
          <label
            style={{ color: "red", fontWeight: "bolder", fontSize: "18px" }}
          >
            *
          </label>
        )}
      </label>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          defaultValue={dayjs(value)}
          variant="outlined"
          slotProps={{ textField: { size: "small", error: isError } }}
          id={id}
          onChange={onChange}
          required={isRequired}
          error={isError}
        />
      </LocalizationProvider>
    </div>
  );
};
